export const colorsTheme = {
  white: '#000000',
  black: '#000000',
  danger: '#F2383A',

  'gradient-deg': '294deg',
  'gradient-primary': '#253439',
  'gradient-secondary': '#253439',

  'primary-color': '#115604',
  'secondary-color': '#115604',
  'auxiliary-color': '#115604',

  'secondary-button-background': 'transparent',
  'secondary-button-background-hover': '#115604',
  'secondary-button-color': '#115604',
  'secondary-button-color-hover': '#000',
  'secondary-button-border': '#115604',
  'secondary-button-border-hover': '#115604',

  'bg-color': '#FFFFFF',
  'bg-secondary-color': '#020330',
  'bg-auxiliary-color': '#EDEDED',

  'bg-circle-color': '#FFFFFF',
  'bg-circle-hover': '#115604',
  'bg-circle-text-color': '#000',
  'bg-circle-text-color-hover': '#FFFFFF',

  'filter-button-background': '#115604',
  'filter-button-color': '#FFFFFF',
  'filter-button-border': '#115604',
  'entry-message-color': '#115604',

  'bg-modal-color': '#FFFFFF',

  'dark-color': '#3F3F3F',

  'text-primary': '#1E1E1E',
  'text-secondary': '#115604;',
  'text-gray': '#4F4F4F',

  'input-color': '#1E1E1E',
  'bg-input-color': '#FFFFFF',
  'info-color': '#B5D3FF',
  'disabled-color': '#e2e2e2',
  'card-color': '#EEEEEE',
  'modal-border-color': '#ADB5BD',
  'border-color': '#115604',

  'echeck-label-color': '#000',
  'echeck-border-color': '#D2D2D2',
  'echeck-text-color': '#000',
  'echeck-bar-color1': '#115604',
  'echeck-bar-color2': '#115604',
};
